import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import EvaluationPage from "./pages/EvaluationPage";
import AdminPage from "./pages/AdminPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#FDFBF7]">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/immobili" element={<PropertiesPage />} />
              <Route path="/immobili/:id" element={<PropertyDetailPage />} />
              <Route path="/chi-siamo" element={<AboutPage />} />
              <Route path="/contatti" element={<ContactPage />} />
              <Route path="/valutazione" element={<EvaluationPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
